import {getIdCompanyByLocalStorage} from "@dropDesk/utils/helpers/common";
import {InternalChatEntity} from "@dropDesk/domain/entities/internal_chat/internal_chat_entity";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {InternalChatUserEntity} from "@dropDesk/domain/entities/internal_chat/users/internal_chat_user_entity";
import {BackendAction} from "@dropDesk/domain/entities/common/actions_entity";

export const newInternalChat = (userLogged: UserEntity) => new InternalChatEntity({
    id: '',
    idCompany: getIdCompanyByLocalStorage(),
    description: '',
    idOpenedByUser:userLogged.id,
    users: [
        new InternalChatUserEntity({
            idCompany: getIdCompanyByLocalStorage(),
            idInternalChat: '',
            idUser: userLogged.id,
            user: UserEntity.fromJson(userLogged.toJson()),
            action: BackendAction.insert
        })
    ],
});
